<template>
  <div>
    <custom-text-reactions-list
      v-if="!isEditMode"
      data-test="reactions-list"
      :event-reactions="eventReactions!"
      @edit-mode-on="editModeOn"
      @back-to-inner-reactions="$emit('backToInnerReactions')"
      @set-reaction="setTextCustomReaction"
    />
    <edit-custom-reaction-dialog
      v-if="isEditMode"
      data-test="edit-dialog"
      @close-reaction-menu="$emit('closeReactionMenu')"
      @edit-mode-off="editModeOff"
    />
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue'

import { CustomTextReactionsList } from '@/entities/custom-text-reactions-list'
import { EditCustomReactionDialog } from '@/entities/edit-custom-reaction-dialog'
import { ReactionsMap } from '@/entities/reaction'

import { EmittedReaction } from '@/shared/types/emitted-reaction'

defineProps<{
  eventReactions?: ReactionsMap
}>()

const emit = defineEmits<{
  (event: 'closeReactionMenu'): void
  (event: 'backToInnerReactions'): void
  (event: 'setReaction', value: EmittedReaction): void
}>()

const isEditMode = ref(false)

const editModeOn = () => {
  isEditMode.value = true
}

const editModeOff = () => {
  isEditMode.value = false
}

const setTextCustomReaction = (reaction: EmittedReaction) => {
  emit('setReaction', reaction)
}
</script>
